import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import FieldInput from '../../form/FieldInput';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import truncateEmail from '../../helpers/truncateEmail';
import Message from '../../../common/message/Message';
import Heading, { HEADING_SIZE } from '../../../common/heading/Heading';
import {
	ACCOUNT_FORGOT_PASSWORD,
	ONBOARDING_LINK_PASSWORD,
	ONBOARDING_PASSWORD_FIELD,
	ONBOARDING_LINK_LOGIN_TITLE,
	ONBOARDING_LINK_LOGIN_CTA,
} from '../../../../constants/Copy';
import { ROUTE_FORGOT_PASSWORD } from '../../../../constants/Routes';
import focusDelay from '../../helpers/focusDelay';

import './LinkAccountsForm.scss';

@reduxForm({
	form: 'linkAccounts',
})
class LinkAccountsForm extends Component {
	password = null;

	static propTypes = {
		email: PropTypes.string.isRequired,
		handleSubmit: PropTypes.func.isRequired,
	};

	componentDidMount() {
		focusDelay(this.password, false);
	}

	render() {
		const { handleSubmit, submitting, pristine, email } = this.props;
		return (
			<form method="post" onSubmit={handleSubmit} className="onboarding__form onboarding-link-form">
				<Heading size={HEADING_SIZE.MEDIUM}>{ONBOARDING_LINK_LOGIN_TITLE}</Heading>

				<p className="onboarding__text">
					<Message
						message={ONBOARDING_LINK_PASSWORD}
						values={{
							email: <strong>{truncateEmail(email, 28)}</strong>,
						}}
					/>
				</p>

				<Field
					name="password"
					element={(element) => (this.password = element)}
					type="password"
					testId="password-input"
					component={FieldInput}
					label={ONBOARDING_PASSWORD_FIELD}
				/>

				<Button type="submit" loading={submitting} disabled={pristine} testId="link-button">
					{ONBOARDING_LINK_LOGIN_CTA}
				</Button>

				<div className="onboarding__options">
					<Link className="onboarding__link" to={ROUTE_FORGOT_PASSWORD}>
						{ACCOUNT_FORGOT_PASSWORD}
					</Link>
				</div>
			</form>
		);
	}
}

export default LinkAccountsForm;
